import React, { Fragment } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import home from '../pages/Home';
import Store from '../pages/Store';
import BookDetails from '../pages/BookDetails';
import BookRegister from '../pages/BookRegister';
import AuthorRegister from '../pages/AuthorRegister';
import Login from '../pages/Login';
import RegisterUser from '../pages/RegisterUser';
import WebBookDetails from '../pages/WebBookDetails';
import WebBookView from '../pages/WebBookView';
import Loader from '../components/Loader';

const Routes = () => (
    <BrowserRouter>
        <Fragment>
            <Loader/>
            <Switch>
                <Route exact path="/"               component={home}           />
                <Route exact path="/Home"           component={home}           />
                <Route exact path="/Loja"           component={Store}          />
                <Route exact path="/Livro/:name"    component={BookDetails}    />
                <Route exact path="/CadastrarAutor" component={AuthorRegister} />
                <Route exact path="/CadastrarLivro" component={BookRegister}   />
                <Route exact path="/login"          component={Login}          />
                <Route exact path="/cadastro"       component={RegisterUser}   />
                <Route exact path="/weblivro"       component={WebBookDetails} />
                <Route exact path="/weblivroview"   component={WebBookView}    />
                <Route component={home} />
             </Switch>
        </Fragment>
    </BrowserRouter>
);
export default Routes;



// WEBPACK FOOTER //
// ./src/routes/index.js